export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "group": {
          "consult": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consulter"])},
          "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer"])},
          "orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commandes"])},
          "pickups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enlèvements"])},
          "notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bons de livraison"])},
          "tools": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outils"])},
          "account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte"])}
        },
        "tabs": {
          "dashboard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accueil"])},
          "orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commandes"])},
          "quotations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devis"])},
          "planning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Planif."])},
          "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus"])}
        },
        "orders": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commandes & Appels & BL"])},
          "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commandes"])},
          "addExpressOrder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvelle commande express"])}
        },
        "quotations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devis"])},
          "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demandes de devis"])},
          "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvelle demande de devis"])}
        },
        "deliveries": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appels de livraison / enlèvement"])},
          "deliveryPending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Livraisons en cours"])},
          "deliveryAccepted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Livraisons acceptées"])},
          "deliveryDelivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Livraisons terminées"])},
          "disputes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Litiges"])},
          "pickupPending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enlèvements en cours"])},
          "addDelivery": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvel appel livraison"])},
          "addPickup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvel appel enlèvement"])}
        },
        "notes": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bons de livraison"])},
          "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En cours"])},
          "delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terminés"])},
          "addPickup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau bon de départ"])}
        },
        "more": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus"])},
          "secondeVie": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bourse aux Matériaux"])},
          "parameters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
        }
      },
      "en": {
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "group": {
          "consult": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Browse"])},
          "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
          "orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orders"])},
          "pickups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pickups"])},
          "notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivery notes"])},
          "tools": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tools"])},
          "account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account"])}
        },
        "tabs": {
          "dashboard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
          "orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orders"])},
          "quotations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quotes"])},
          "planning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Planning"])},
          "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More"])}
        },
        "orders": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orders & Calls & DN"])},
          "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orders"])},
          "addExpressOrder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New express order"])}
        },
        "quotations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quotes"])},
          "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quote requests"])},
          "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New quote request"])}
        },
        "deliveries": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivery / Pickup calls"])},
          "deliveryPending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deliveries in progress"])},
          "deliveryAccepted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accepted deliveries"])},
          "deliveryDelivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completed deliveries"])},
          "disputes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disputes"])},
          "pickupPending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pickups in progress"])},
          "addDelivery": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New delivery call"])},
          "addPickup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New pickup call"])}
        },
        "notes": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivery notes"])},
          "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upcoming"])},
          "delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivered"])},
          "addPickup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New pickup note"])}
        },
        "more": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More"])},
          "secondeVie": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bourse aux Matériaux"])},
          "parameters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parameters"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log out"])}
        }
      }
    }
  })
}